import { BaseModel } from "@blue-chip/core";
import Location from "./Location";

export default class ConsultingCompany extends BaseModel {
  static get belongsTo() {
    return [Location];
  }
}
